import { NgIf } from '@angular/common'
import { Component } from '@angular/core'
import { ActivatedRoute, NavigationEnd, Router, RouterLink, RouterOutlet } from '@angular/router'
import { filter } from 'rxjs/internal/operators/filter'
import { AdminActionsComponent } from 'src/app/admin/admin-actions/admin-actions.component'
import { SidebarComponent } from 'src/app/common-components/molecules/sidebar/sidebar.component'
import { ShopifyService } from 'src/app/services'
import { environment } from 'src/environments/environment'
@Component({
	selector: 'layout-window',
	styleUrls: ['./window.component.scss'],
	templateUrl: './window.component.html',
	standalone: true,
	imports: [RouterLink, SidebarComponent, NgIf, RouterOutlet, AdminActionsComponent],
})
export class LayoutWindow {
	environment = environment
	mode: boolean
	_currentUrl: string
	constructor(public route: ActivatedRoute, public router: Router, private shopifyService: ShopifyService) {
		this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe(() => {
			this._currentUrl = this.router.url
		})
	}

	back() {
		window.history.back()
	}

	deepLinkUrl() {
		window.open(this.shopifyService.deeplinkInstall(), '_blank')
	}

	intercom() {
		;(window as any)['Intercom']('show')
	}
}
